import React from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Card, Spin, Table } from 'antd'
import moment from 'moment'
import subscriptions from '@services/subscriptions'
import users from '@services/users'
import { alertPopup } from '@utils/popup'
class SpecialSubscriptions extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            list: [],
            editId: null,
            memberListId: null,
            loadingCancel: false,
            flyExpiration: null
        }
    }

    componentDidMount() {
        this.getSpecialSubscriptions()
        this.getFlyMaxExpiration()
    }

    componentDidUpdate(prevProps) {
        const prevId = prevProps.clientInfo && prevProps.clientInfo.id
        const currentId = this.props.clientInfo && this.props.clientInfo.id
        if (prevId !== currentId) {
            this.getSpecialSubscriptions()
        }
    }

    // Safely parse a JSON string (e.g. dates_range); returns {} on absence/invalid JSON.
    safeParse = value => {
        if (!value) return {}
        try {
            return JSON.parse(value)
        } catch (e) {
            return {}
        }
    }

    // A subscription is actionable only when its start date is present, valid and in the future.
    hasValidFutureStart = value => {
        const { start } = this.safeParse(value)
        if (!start) return false
        const time = new Date(start).getTime()
        if (isNaN(time)) return false
        return time > new Date().getTime()
    }

    getSpecialSubscriptions = () => {
        const { clientInfo } = this.props
        users
            .getSpecialSubscriptionsByUser({ user_id: clientInfo.id })
            .then(res => {
                // sort ?
                this.sortSubscriptions(res.data)
                this.setState({ list: res.data })
            })
            .catch(error => {
                console.log('special-subscriptions. error', error)
                // alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'לא ניתן להציג את המידע' })
            })
    }

    getFlyMaxExpiration = () => {
        subscriptions
            .getFlyMaxExpiration()
            .then(res => {
                const { flyExpiration } = res.data
                this.setState({ flyExpiration })
            })
            .catch(error => {
                console.log('getFlyMaxExpiration', error)
            })
    }

    sortSubscriptions = subs => {
        const subDate = ({ dates_range, created_at }) => {
            let date = this.safeParse(dates_range).start
            return date ? new Date(date).getTime() : new Date(created_at || null).getTime()
        }

        subs.sort((a, b) => (subDate(a) > subDate(b) ? -1 : 1))
    }

    cancelSpecialSubscription = subscriptionId => {
        this.setState({ loadingCancel: true }, () => {
            subscriptions
                .cancelSpecialSubscription({ subscriptionId })
                .then(res => {
                    this.getSpecialSubscriptions()
                })
                .catch(error => {
                    console.log('error', error)
                    alertPopup({ type: 'error', title: 'אירעה שגיאה בעת ביטול המינוי', body: '' })
                })
                .finally(() => {
                    this.setState({ loadingCancel: false, editId: null })
                })
        })
    }

    columns = [
        {
            title: 'מוצר',
            key: 'product',
            align: 'right',
            render: (_, record) => <span>{`${record.subscription_name}`}</span>
        },
        {
            title: 'מחיר',
            key: 'price',
            align: 'right',
            render: (_, record) => <span>{`₪${record.price}`}</span>
        },
        {
            title: 'נכלל/ת במינוי?',
            key: '',
            align: 'right',
            render: (_, record) => {
                const {
                    clientInfo: { id: clientId }
                } = this.props

                // if (record.user_id == clientId) {
                //     return <span>{"כן (נוסע ראשי)"}</span>
                // } else if (record.members.find(({ id }) => id == clientId)) {

                //     const { main_user_first, main_user_last, user_id } = record
                //     const link = <a target="_blank" href={`/clients/${user_id}`}>{`${main_user_first} ${main_user_last}`}</a>

                //     return (
                //         <span>
                //             {"נכלל/ת במינוי של "}
                //             {link}
                //         </span>
                //     )
                // } else {
                //     return <span>{"לא"}</span>
                // }

                if (!record.members.find(({ id }) => id == clientId)) {
                    // not a member
                    return <span>{'לא'}</span>
                } else if (record.user_id == clientId) {
                    // member and main-user
                    return <span>{'כן (נוסע ראשי)'}</span>
                } else {
                    // member only. not main-user
                    const { main_user_first, main_user_last, user_id } = record
                    const link = (
                        <a target="_blank" href={`/clients/${user_id}`}>{`${main_user_first} ${main_user_last}`}</a>
                    )

                    return (
                        <span>
                            {'נכלל/ת במינוי של '}
                            {link}
                        </span>
                    )
                }
            }
        },
        {
            title: 'נרכש ע״י',
            key: 'paid_by',
            align: 'right',
            render: (_, record) => {
                return <span>{`${record.paid_by_first} ${record.paid_by_last} ${record.paid_by_id}`}</span>
            }
        },
        {
            title: 'תאריך רכישה',
            key: 'paid_at',
            align: 'right',
            render: (_, record) => <span>{moment(record.paid_at).format('DD/MM/YY')}</span>
        },
        {
            title: 'תאריכים',
            key: 'dates_range',
            align: 'right',
            render: (_, record) => {
                let { start, end } = this.safeParse(record.dates_range)
                const error = !start || !end
                start = moment(start).format('DD/MM/YY')
                end = moment(end).format('DD/MM/YY')
                return error ? <span>{'שגיאה'}</span> : <span>{`התחלה: ${start} | סיום: ${end}`}</span>
            }
        },
        {
            title: 'ניתן להגיש בקשה?',
            key: 'requestEligible',
            align: 'right',
            render: (_, record) => {
                const { flyExpiration } = this.state
                let { end } = this.safeParse(record.dates_range)
                let error = !end || flyExpiration == null
                end = new Date(end)
                let now = new Date().getTime()
                let dif = now - end.getTime()
                let status

                if (flyExpiration || flyExpiration == 0) {
                    if (dif < 0) status = 'not_yet'
                    else if (dif / flyExpiration <= 86400000) status = 'yes'
                    else status = 'not_anymore'
                }

                if (error) status = 'error'

                let statuses = {
                    not_yet: 'עדיין לא',
                    yes: `כן (עד ל- ${moment(end.getTime() + 86400000 * (flyExpiration - 1)).format('DD/MM/YY')})`,
                    not_anymore: 'לא',
                    error: 'שגיאה'
                }

                return <span>{`${statuses[status]}`}</span>
            }
        },
        {
            title: 'נוסעים',
            key: 'members',
            align: 'right',
            render: (_, record) => {
                if (this.state.memberListId == record.id) {
                    return (
                        <div style={{ position: 'relative' }}>
                            <div style={{ ...styles.memberList }}>
                                <span
                                    style={{ ...styles.closeMemberList }}
                                    onClick={() => this.setState({ memberListId: null })}
                                >
                                    {'+'}
                                </span>

                                {record.members.map((member, idx) => {
                                    const link = (
                                        <a
                                            target="_blank"
                                            href={`/clients/${member.id}`}
                                            style={{ color: 'rgba(0, 0, 0, 0.65)' }}
                                        >
                                            {`${member.first_name} ${member.last_name} ${member.id}`}
                                        </a>
                                    )
                                    return (
                                        <div key={idx.toString()} style={{ ...styles.memberListItem }}>
                                            {link}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                } else {
                    return <Button onClick={() => this.setState({ memberListId: record.id })}>{'נוסעים'}</Button>
                }
            }
        },

        {
            title: '',
            key: 'cancelRequest',
            align: 'right',
            render: (_, record) => {
                const {
                    clientInfo,
                    clientInfo: { id: clientId }
                } = this.props
                const {
                    authStore: { roles },
                    popupStore
                } = this.props
                const updatedAt = moment(record.updated_at).format('DD/MM/YY')

                if (record.status === 'CANCELED') {
                    return <span style={{ fontSize: '14px', color: 'red' }}>{`בוטל בתאריך ${updatedAt}`}</span>
                } else if (record.cancellation_requested) {
                    return <span>{'הוגשה בקשת ביטול'}</span>
                } else if (record.paid_by != clientId && record.user_id != clientId) {
                    return ''
                } else if (!this.hasValidFutureStart(record.dates_range)) {
                    // Past or missing/invalid start date: not actionable.
                    return roles.includes('admin') || roles.includes('money') ? '' : <span>{'לא ניתן לבטל'}</span>
                } else {
                    return (
                        <Button
                            onClick={() => {
                                popupStore.togglePopup('CreateCancellationRequest', {
                                    title: 'בקשת ביטול מינוי',
                                    clientInfo,
                                    specialSub: record,
                                    getSpecialSubscriptions: this.getSpecialSubscriptions
                                })
                            }}
                        >
                            {'בקשת ביטול'}
                        </Button>
                    )
                }
            }
        }
    ]

    adminMoneyColumns = [
        {
            title: '',
            key: 'edit',
            align: 'right',
            render: (_, record) => {
                const {
                    clientInfo: { id: clientId }
                } = this.props
                const { editId, memberListId } = this.state

                if (record.status === 'CANCELED') return ''
                else if (!this.hasValidFutureStart(record.dates_range)) {
                    // Past or missing/invalid start date: cannot cancel.
                    return <span>{'לא ניתן לבטל'}</span>
                } else if (record.paid_by != clientId && record.user_id != clientId) {
                    return <span>{'ביטול בעמוד משתמש ראשי'}</span>
                } else if (editId == record.id) {
                    return (
                        <div>
                            <span>{'האם לבטל את המינוי?'}</span>
                            <div>
                                <Button
                                    disabled={this.state.loadingCancel}
                                    onClick={() => this.cancelSpecialSubscription(record.id)}
                                >
                                    {'כן'}
                                </Button>
                                <Button onClick={() => this.setState({ editId: null })}>{'לא'}</Button>
                                {this.state.loadingCancel && <Spin />}
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <Button
                                style={{ color: 'red' }}
                                onClick={() => !memberListId && this.setState({ editId: record.id })}
                            >
                                {'ביטול מינוי'}
                            </Button>
                        </div>
                    )
                }
            }
        }
    ]

    statuses = {
        ACTIVE: {
            text: 'פעיל',
            color: 'green'
        },
        CANCELED: {
            text: 'מבוטל',
            color: 'gray'
        }
    }

    render() {
        const { list } = this.state
        const {
            authStore: { roles }
        } = this.props

        let columns = []

        if (roles.includes('admin') || roles.includes('money')) {
            columns = [...this.columns, ...this.adminMoneyColumns]
        } else {
            columns = [...this.columns]
        }

        return list.length ? (
            <div style={{}}>
                <Card
                    title={<span>{'מינויים מיוחדים'}</span>}
                    headStyle={{ backgroundColor: '#dadce0' }}
                    style={{ marginBottom: '1rem' }}
                >
                    <Table columns={columns} rowKey="id" dataSource={list} />
                </Card>
            </div>
        ) : (
            ''
        )
    }
}

const styles = {
    memberList: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        borderRadius: '4px',
        border: 'solid rgb(209 205 201) 1px',
        width: '200px',
        // minHeight: '101px',
        maxHeight: '135px',
        paddingBottom: '15px',
        overflowY: 'auto',
        zIndex: '1',
        position: 'absolute',
        right: '-78px',
        top: '-17px'
    },

    closeMemberList: {
        alignSelf: 'flex-start',
        rotate: '45deg',
        fontSize: '24px',
        cursor: 'pointer',
        margin: '-8px 1px 0 0'
    },

    memberListItem: {
        alignSelf: 'center',
        padding: '3px 0'
    }
}

export default inject('authStore', 'popupStore')(observer(SpecialSubscriptions))
